import React from 'react'

import {ReportMobileDetails} from 'template'

export default function Index() {
  return <ReportMobileDetails />
}
